module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71016/img/payment_methods.png"